// services/api/BaseService.ts
import { axiosService } from "@services/AxiosService";
import { errorMessagesHandling } from "@utils/errorHandler";
import { AxiosResponse } from "axios";
export class BaseService {
  protected async get<T = any>(
    path: string,
    config = {},
    errorText?: string
  ): Promise<T | AxiosResponse<T>> {
    try {
      const response: AxiosResponse<T> = await axiosService.get(path, config);

      // Return data if it exists, otherwise return full response
      if (response?.data) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      errorMessagesHandling(error, errorText);
      throw error;
    }
  }

  protected async post<T = any>(
    path: string,
    data?: any,
    config = {},
    errorText?: string,
    fullResponse = false
  ): Promise<T | AxiosResponse<T>> {
    try {
      const response = await axiosService.post<T>(path, data, config);

      if (fullResponse) {
        return response;
      }

      if (response?.data) {
        return response.data;
      } else if (response?.status === 200 || response?.status === 201) {
        return response;
      }

      // ✅ fallback (in case neither condition matched)
      return response;
    } catch (error) {
      errorMessagesHandling(error, errorText);
      throw error;
    }
  }

  protected async patch<T = any>(
    path: string,
    data: any,
    config = {},
    errorText?: string
  ): Promise<T> {
    try {
      const response = await axiosService.patch(path, data, config);
      return response.data;
    } catch (error) {
      errorMessagesHandling(error, errorText);
      throw error;
    }
  }

  protected async put<T = any>(
    path: string,
    data: any,
    config = {},
    errorText?: string
  ): Promise<T> {
    try {
      const response = await axiosService.put(path, data, config);
      return response.data;
    } catch (error) {
      errorMessagesHandling(error, errorText);
      throw error;
    }
  }

  protected async delete<T = any>(
    path: string,
    config = {},
    errorText?: string
  ): Promise<T> {
    try {
      const response = await axiosService.delete(path, config);
      return response.data;
    } catch (error) {
      errorMessagesHandling(error, errorText);
      throw error;
    }
  }
}
